import { persistentStorage } from 'reactor-js-core/dist/persistentstorage.js'

function rejectAllCookies() {
  persistentStorage.set("cookie_consent", "accepted");
  persistentStorage.set("cookie_performance", "denied");
  persistentStorage.set("cookie_functional", "denied");
}

function acceptAllCookies() {
  persistentStorage.set("cookie_consent", "accepted");
  persistentStorage.set("cookie_performance", "accepted");
  persistentStorage.set("cookie_functional", "accepted");
}

function hasAcceptedCookies() {
  return persistentStorage.get("cookie_consent") === "accepted";
}

function hasAcceptedPerformance() {
  return persistentStorage.get("cookie_performance") === "accepted";
}

function hasAcceptedFunctional() {
  return persistentStorage.get("cookie_functional") === "accepted";
}

function setPerformance(performance) {
  if (performance) {
    persistentStorage.set("cookie_performance", "accepted");
  }
  else {
    persistentStorage.set("cookie_performance", "denied");
  }
}

function setFunctional(functional) {
  if (functional) {
    persistentStorage.set("cookie_functional", "accepted");
  }
  else {
    persistentStorage.set("cookie_functional", "denied");
  }
}

function setConsentAccepted() {
  persistentStorage.set("cookie_consent", "accepted");
}

function getConsentTransferParameter() {
  if (hasAcceptedCookies()) {
    let param = "a";
    if (hasAcceptedPerformance()) param += "p";
    if (hasAcceptedFunctional()) param += "f";
    return "&cookie_consent=" + encodeURIComponent(param);
  }
  else {
    return "";
  }
}

function parseConsentTransferParameter(query) {
  if (hasAcceptedCookies()) return;

  if (query['cookie_consent'] != null) {
    let param = query['cookie_consent'];
    if (param.includes("a")) {
      setPerformance(param.includes("p"));
      setFunctional(param.includes("f"));
      setConsentAccepted();
    }
  }
}

const getCookieValue = (name) => {
  return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
}

function parseOnetrustConsent() {
  if (hasAcceptedCookies()) return;

  //this is the Onetrust cookie consent that is made on www.vevox.com
  //if anything is changed in regards to that consent dialog this code need to change as well

  let optanon_consent = getCookieValue("OptanonConsent");

  if (optanon_consent == null) return;

  let search_params = new URLSearchParams(optanon_consent);

  let interaction_count = search_params.get("interactionCount");
  if (interaction_count == null || interaction_count == "0") return;

  let groups_str = search_params.get("groups");

  if (groups_str == null) return;

  let groups_array = groups_str.split(',');

  setPerformance(groups_array.includes("2:1"));
  setFunctional(groups_array.includes("3:1"));
  setConsentAccepted();
}

export default {
  rejectAllCookies,
  acceptAllCookies,
  hasAcceptedCookies,
  hasAcceptedPerformance,
  hasAcceptedFunctional,
  setPerformance,
  setFunctional,
  setConsentAccepted,
  getConsentTransferParameter,
  parseConsentTransferParameter,
  parseOnetrustConsent,
}


// WEBPACK FOOTER //
// ./src/js/cookieconsent.js